import { Helmet } from "react-helmet";
import MantenimientosPrepagados from "../mantenimientoPrepagado1/MantenimientosPrepagados";
function MatenimientosPrepagados() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Helmet>
        <meta
          name="description"
          content="Cotiza hoy tus matenimientos prepagados y ahorra hasta un 20% en cualquier concesionario Hyundai"
        />
        <meta
          name="keywords"
          content="Mantenimientos Hyundai, Repuestos, Servicio, red de servicio, servicio Hyundai"
        />
        <title>Mantenimiento Prepagado Hyundai</title>
      </Helmet>
      <MantenimientosPrepagados style={{ flexGrow: 1 }} />
    </div>
  );
}
export default MatenimientosPrepagados;